<template>
  <div class="dropdown fav-drop-down" v-show="showFavDropDown">
    <button class="btn dropdown-toggle" type="button" data-toggle="dropdown">
      <i class="star-yellow fa fa-star" aria-hidden="true"></i>
      <span class="caret"></span>
    </button>
    <ul class="dropdown-menu ul-fav">
      <li v-for="(item, index) in sortingToShow()" :key="index">
        <a
          ><i
            class="fa fa-trash"
            aria-hidden="true"
            @click="deleteFromList(index)"
            :key="index"
          ></i>
          <span @click="applyFav(item)">{{ "FAV #" }}{{ index + 1 }}</span>

          <div class="list-of-favs-tags">
            <div v-for="tag in item.tags" :key="tag">{{ "-" }}{{ tag }}</div>
          </div>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "FavDropDown.Component",
  data() {
    return {
      allFaves: [],

      showFavDropDown: false
    };
  },
  computed: {
    ...mapState("clients", ["addFavToList"])
  },
  mounted() {
    this.setListOfFavs();
  },
  watch: {
    allFaves: function() {
      if (this.allFaves.length > 0) {
        this.showFavDropDown = true;
      } else {
        this.showFavDropDown = false;
      }
    },
    addFavToList: function() {
      if (this.addFavToList) {
        this.setListOfFavs();
        this.$store.commit("clients/setAddFavToList", false);
      }
    }
  },
  methods: {
    sortingToShow() {
      let countToShow = 5;
      let tempObj = [Object.assign(this.allFaves)];

      tempObj = tempObj.sort((a, b) => {
        if (a.count > b.count) {
          return -1;
        }
        if (a.count < b.count) {
          return 1;
        }
        return 0;
      });

      tempObj = tempObj[0].slice(0, countToShow);

      return tempObj;
    },
    deleteFromList(index) {
      this.allFaves.splice(index, 1);
      localStorage.setItem("Favorites", JSON.stringify(this.allFaves));
    },
    setListOfFavs() {
      this.allFaves = [];
      let tempObj = [];

      if (localStorage.getItem("Favorites")) {
        tempObj = JSON.parse(localStorage.getItem("Favorites"));
      }

      if (tempObj.length > 0) {
        this.showFavDropDown = true;

        tempObj.map(data => {
          this.allFaves.push(data);
        });
      }
    },
    applyFav(query) {
      this.$store.commit("clients/setQueryFromFavs", query.data);
    }
  }
};
</script>

<style scoped>
.fav-drop-down {
  position: absolute;
  background: none;
  right: 80px;
  padding: 0px;
  /* margin-right: 2px; */
  /* margin-top: 2px; */
  top: 228px;
  /* margin-right: 2px; */
  /* margin-top: 2px; */
  /* height: 13px; */
  transform: scale(1.1);
}
.fav-drop-down ul li:hover {
  cursor: pointer;
}
.ul-fav li {
  margin: 5px;
}
.ul-fav li i {
  margin-right: 20px;
  color: #96281b;
}
.ul-fav li:not(:last-child):after {
  //border-bottom: 1px solid rgba(116, 171, 203, 0.5);
  content: ""; /* This is necessary for the pseudo element to work. */
  display: block; /* This will put the pseudo element on its own line. */
  margin: 0 auto; /* This will center the border. */
  width: 70%; /* Change this to whatever width you want. */

  border-bottom: 1px solid rgba(222, 220, 220, 0.36); /* This creates the border. Replace black with whatever color you want. */
}
.list-of-favs-tags {
  font-size: 10px;
  max-width: 250px;
  word-wrap: break-word;
  font-weight: bold;
  margin-top: 5px;
}
.dropdown-toggle {
  border-radius: 0px !important;
  font-size: 12px !important;
  text-transform: uppercase !important;
  /*background: white;*/
  background: transparent;
}
.star-yellow {
  color: yellow;
  font-size: 1.5em;
}
.dropdown-menu {
  left: -119px;
}
* {
  outline: none !important;
}
</style>
